(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-kb"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('[data-bt-kb]');
    if(!root)return;
    var chips=Array.prototype.slice.call(root.querySelectorAll('.bt-kb-chip'));
    var cards=Array.prototype.slice.call(root.querySelectorAll('.bt-kb-card'));
    var search=root.querySelector('[data-bt-kb-search]');
    var countEl=root.querySelector('[data-bt-kb-count]');
    var totalEl=root.querySelector('[data-bt-kb-total]');
    var emptyEl=root.querySelector('[data-bt-kb-empty]');
    var clearBtns=Array.prototype.slice.call(root.querySelectorAll('[data-bt-kb-clear]'));
    var total=cards.length;
    var tagsOf=function(c){return (c.getAttribute('data-tags')||'').split('|');};
    chips.forEach(function(chip){var tag=chip.getAttribute('data-tag');var n=0;cards.forEach(function(c){if(tagsOf(c).indexOf(tag)!==-1)n++;});var cEl=chip.querySelector('.bt-kb-chip__count');if(cEl)cEl.textContent=n;});
    function apply(){
      var map={};
      chips.forEach(function(chip){if(chip.classList.contains('is-active')){var ax=chip.getAttribute('data-axis');(map[ax]=map[ax]||[]).push(chip.getAttribute('data-tag'));}});
      var axes=Object.keys(map);
      var q=((search&&search.value)||'').trim().toLowerCase();
      var shown=0;
      cards.forEach(function(card){
        var tags=tagsOf(card);var ok=true;
        for(var i=0;i<axes.length;i++){var wanted=map[axes[i]];var hit=false;for(var j=0;j<wanted.length;j++){if(tags.indexOf(wanted[j])!==-1){hit=true;break;}}if(!hit){ok=false;break;}}
        if(ok&&q){var title=(card.getAttribute('data-title')||'').toLowerCase();if(title.indexOf(q)===-1)ok=false;}
        card.style.display=ok?'':'none';if(ok)shown++;
      });
      if(countEl)countEl.textContent=shown;
      if(totalEl)totalEl.textContent=total;
      if(emptyEl)emptyEl.hidden=shown!==0;
      var anyActive=axes.length>0||q.length>0;
      clearBtns.forEach(function(b){b.hidden=!anyActive;});
    }
    chips.forEach(function(chip){chip.addEventListener('click',function(){chip.classList.toggle('is-active');apply();});});
    if(search)search.addEventListener('input',apply);
    clearBtns.forEach(function(b){b.addEventListener('click',function(){chips.forEach(function(c){c.classList.remove('is-active');});if(search)search.value='';root.classList.remove('bt-kb--filters-open');apply();});});
    var toggle=root.querySelector('[data-bt-kb-toggle]');
    if(toggle)toggle.addEventListener('click',function(){root.classList.toggle('bt-kb--filters-open');});
    try{var params=new URLSearchParams(window.location.search);var pre=params.get('tags')||params.get('tag');if(pre){var want=pre.split(',').map(function(s){return s.trim();});chips.forEach(function(chip){if(want.indexOf(chip.getAttribute('data-tag'))!==-1)chip.classList.add('is-active');});}}catch(e){}
    apply();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
